import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function F() {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('save_electric');
    const router = useRouter();

    const gotoPage = (data: any) => {
        const { link, name } = data;
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: name,
            position: 'Electricity Saving',
        });
        router.push(link);
    };

    return (
        <div className={`save-electric-f ${css.SaveElectricF}`}>
            <section className="section-a text-wrapper">
                <h2 className="sub-title">{t('sec_8_subtitle')}</h2>
                <p className="title">{t('sec_8_title')}</p>
                <p className="desc">{t('sec_8_desc')}</p>
            </section>
            <section className="section-b">
                <div className="box">
                    <NextImage
                        webpSrc="https://websiteoss.ecoflow.com/upload/image/1730190462100/jp-soeb-img.jpg"
                        src="https://websiteoss.ecoflow.com/upload/image/1730190462100/jp-soeb-img.jpg"
                        alt={t('sec_9_title1')}
                        aria-label={t('sec_9_title1')}
                    />
                    <div className="text">
                        <p className="title">{t('sec_9_title1')}</p>
                        <p className="desc">{t('sec_9_desc1')}</p>
                        <p
                            className="learn-more"
                            onClick={() => gotoPage({ name: t('sec_9_title1'), link: 'https://jp.ecoflow.com/products/ecoflow-220w-solarpanel-new' })}
                        >
                            {t('btn')}
                        </p>
                    </div>
                </div>
                <div className="box box-2">
                    <NextImage
                        webpSrc={require('@publicLocal/save-electric/h5/9-2.webp')}
                        src={require('@publicLocal/save-electric/h5/9-2.jpg')}
                        alt={t('sec_9_title2')}
                        aria-label={t('sec_9_title2')}
                    />
                    <div className="text">
                        <p className="title">{t('sec_9_title2')}</p>
                        <p className="desc">{t('sec_9_desc2')}</p>
                        <p
                            className="learn-more"
                            onClick={() => gotoPage({ name: t('sec_9_title2'), link: 'https://jp.ecoflow.com/products/400w-solar-panel' })}
                        >
                            {t('btn')}
                        </p>
                    </div>
                </div>
            </section>
            <p className="section-c">{t('sec_9_text')}</p>
        </div>
    );
}
